import { render, staticRenderFns } from "./PackageDetail.vue?vue&type=template&id=0e726b2a"
import script from "./PackageDetail.vue?vue&type=script&lang=js"
export * from "./PackageDetail.vue?vue&type=script&lang=js"
import style0 from "./PackageDetail.vue?vue&type=style&index=0&id=0e726b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports